<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { toast, variants } from "@/helpers/toaster";
import store from '@/state/store';

export default {
  page: {
    title: "Porudžbenice",
  },
  components: {PageHeader, Layout},
  props: {
  },
  data() {
    return {
      title: 'Porudžbenice',
      fields: [
        {key: 'real_item_id', label: 'ID', sortable: false},
        {key: 'name', label: 'Artikal', sortable: true, sortByFormatted: true, formatter: (value, key, item) => item.name2?.toLowerCase()},
        {key: 'code', label: 'Šifra', sortable: true},
        {key: 'number_in_package', label: 'Pak', sortable: false},
        {key: 'jm', label: 'JM', sortable: false},
        {key: 'price', label: 'Cena', sortable: false},
        {key: 'rebate', label: 'Rabat', sortable: false},
        {key: 'price_with_rebate', label: 'Cena sa Rabatom', sortable: false},
        {key: 'limit', label: 'Limit', sortable: false, editable: false},
        {key: 'amount', label: 'Količina', sortable: false, editable: true},
      ],
      statuses: [
        { key: 'ALLOW_ORDERING', value: 'Aktivan' },
        { key: 'DISALLOW_ORDERING', value: 'Neaktivan' },
        { key: 'SOFT_ORDERED', value: 'Poslato' }
      ],
      status: '',
      search: '',
      selectedGroup: null,
      selectedOrderForm: null,
      groups: [],
      orderForms: [],
      orderFormItems: [],
      budget: 0,
      showPrices: true,
      showRebate: true,
      showPricesWithRebate: true,
      showLimit: true,
      showIds: true,
      showCodes: true,
      showNumberInPackage: true,
      showJm: true,
      note: '',
      showOrdered: false,
      isInitial: true,
      deadline: null,
    }
  },
  watch: {
    showOrdered(v) {
      this.search = '';
    },
    selectedGroup() {
      if (this.isInitial) {
        this.isInitial = false;
      } else {
        this.showOrdered = false;
        this.search = '';
      }
      this.loadOrderForms();
    },
    selectedOrderForm() {
      this.loadOrderForm();
    },
  },
  computed: {
    isSaveDisabled() {
      if (!this.selectedOrderForm) {
        return true;
      }

      if (this.budget && this.totalPrice > this.budget)
        return true;

      if (this.status !== 'ALLOW_ORDERING' ) {
        return true
      }

      return !this.orderFormItems.every(i => this.validateItem(i));
    },
    computedGroups() {
      if (!this.groups) return [];

      return this.groups.map((g) => {
        return {
          value: g,
          text: g.name,
        }
      });
    },
    computedFields() {
      const allowedFields = ['name', 'amount']

      if (this.showPrices) {
        allowedFields.push('price');
      }

      if (this.showCodes) {
        allowedFields.push('code')
      }

      if (this.showRebate) {
        allowedFields.push('rebate')
      }

      if (this.showPricesWithRebate) {
        allowedFields.push('price_with_rebate')
      }

      if (this.showIds) {
        allowedFields.push('real_item_id')
      }

      if (this.showLimit) {
        allowedFields.push('limit')
      }

      if (this.showNumberInPackage) {
        allowedFields.push('number_in_package');
      }

      if (this.showJm) {
        allowedFields.push('jm')
      }

      return this.fields.filter(f => allowedFields.includes(f.key));
    },
    totalPrice() {
      let price = 0;
      for (const orderFormItem of this.orderFormItems) {
        if (orderFormItem.amount) {
          price += orderFormItem.amount * orderFormItem.price
        }
      }
      return price;
    },
    searchedOrderFormItems () {
      let searched = this.orderFormItems.filter((orderFormItem) => {
        let include = false;
        // search name
        include ||= orderFormItem.name2?.toLowerCase().includes(this.search.toLowerCase());
        // search id
        include ||= orderFormItem.real_item_id?.toString().includes(this.search.toLowerCase());

        return include;
      });

      if (this.showOrdered) {
        searched = searched.filter((item) => item.amount > 0)
      }

      return searched
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      axios.get('/employee/groups').then(response => {
        this.groups = response.data;
      })
      this.deadline = this.$store.getters['user/orderDeadline'];
      
    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  methods: {
    async loadOrderForms() {
      if (this.selectedGroup == null) {
        return;
      }

      this.$store.commit('loader/START_LOADING');
      try {
        const orderFormsResponse = await axios.get(`/employee/orderForms/withGroup/${this.selectedGroup.id}`);
        if (orderFormsResponse.data && !!orderFormsResponse.data.order_form) {
          this.note = orderFormsResponse.data.order_form.employeeNote;
          this.selectedOrderForm = orderFormsResponse.data.order_form;
        }
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    openWindow(itemId) {
      const url = `https://www.bigznet.rs/image/catalog/net/${itemId}`;
      window.open(
        url, 
        '_blank', 
        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600,popup'
      );
    },
    async loadOrderForm() {
      if (this.selectedOrderForm == null) {
        return;
      }

      const orderFormResponse = await axios.get(`/employee/orderForms/${this.selectedOrderForm.id}/itemsAndLimitsForGroup`);
      this.budget = orderFormResponse.data.budget
      this.orderFormItems = orderFormResponse.data.items;
      this.showPrices = orderFormResponse.data.show_prices;
      this.showRebate = orderFormResponse.data.show_rebate;
      this.showCodes = orderFormResponse.data.show_codes;
      this.showIds = orderFormResponse.data.show_ids;
      this.showLimit = orderFormResponse.data.show_limit;
      this.showPricesWithRebate = orderFormResponse.data.show_price_with_rebate;
      this.showNumberInPackage = orderFormResponse.data.show_package_to_employees;
      this.showJm = orderFormResponse.data.show_jm_to_employees
      for (const orderFormItem of this.orderFormItems) {
        this.$set(orderFormItem, 'isValid', true);
        this.$set(orderFormItem, 'validationMessage', "");
        // Validate items that already have amounts so the user sees which ones are invalid
        if (orderFormItem.amount) {
          this.onAmountEdit(orderFormItem, orderFormItem.amount);
        }
      }
      this.status = orderFormResponse.data.status;

      if (this.status !== 'ALLOW_ORDERING' ) {
        store.commit('errorBag/RECORD', { status:["Porudžbina je zatvorena i u postupku odobrenja. Više nisu dozvoljene izmene."]});
      }
    },
    async downloadOrderFormItems() {
      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.get(`/employee/orderForms/withGroup/export/excel/${this.selectedGroup.id}`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'porudžbenice.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje porudžbenice.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    calculatePercentage(current, total) {
      if (total === 0) {
          return 0;
      }
      const percentage = ((current / total) * 100)
      return (percentage > 100 ? 100 : percentage.toFixed(2)) + "%";
    },
    save() {
      const items = this.orderFormItems.filter(i => i.amount).map(i => {
          return { 
            item_id: i.id,
            amount: i.amount,
          }
        });
      this.$store.commit('loader/START_LOADING');

      axios.patch(`/employee/orderForms/${this.selectedOrderForm.id}`, {
        items: items,
        employeeNote: this.note,
      })
        .then(() => {
          // Handle success
          toast('Uspešno snimljene izmene.', variants.SUCCESS)
        })
        .finally(() => {
          this.$store.commit('loader/END_LOADING');
        });
    },
    validateItem(item) {
      if (item.number_in_package && item.amount % item.number_in_package !== 0) {
        return false;
      }

      if (item.limit && item.limit !== 0 && item.amount > item.limit) {
        return false;
      }

      if (item.limit == 0 && item.amount > 0) {
        return false;
      }

      if (item.amount < 0) {
        return false;
      }

      return true;
    },
    onAmountEdit(item, value) {
      this.$set(item, 'isValid', true);
      this.$set(item, 'validationMessage', "");

      if (!value) {
        value = null;
      }

      this.$set(item, 'amount', value);

      if (item.number_in_package && value % item.number_in_package !== 0) {
        this.$set(item, 'isValid', false);
        this.$set(item, 'validationMessage', `Broj artikla u paketu je ${item.number_in_package}. Odaberite količinu deljivu sa ${item.number_in_package}.` );
        return;
      }

      if (item.limit && item.limit !== 0 && value > item.limit) {
        this.$set(item, 'isValid', false);
        this.$set(item, 'validationMessage', "Prekoračen limit.");
        return;
      }

      if (item.amount < 0) {
        this.$set(item, 'isValid', false);
        this.$set(item, 'validationMessage', "Vrednost ne može biti negativna.");
        return;
      }

      if (item.limit == 0 && item.amount > 0) {
        this.$set(item, 'isValid', false);
        this.$set(item, 'validationMessage', "Prekoračen limit.");
        return;
      }
    },
  }
}
</script>

<template>
  <Layout>
    <b-alert
      v-if="deadline"
      class="mt-3"
      variant="warning"
      show=""
      dismissible
    >
      <b>Obaveštenje</b>: Postupak popunjavanja liste za poručivanja zatvara se dana {{ new Date(deadline).toLocaleDateString('sr-RS', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '.') }}
    </b-alert>
    <PageHeader :title="title"/>

    <div class="row mb-2">
      <div class="col-12 col-md-6 d-flex">
        <label class="col-form-label mr-2" for="groups">Grupa:</label>
        <b-form-select v-model="selectedGroup" :options="computedGroups">
          <template #first>
            <b-form-select-option :value="null" disabled>-- Izaberi grupu --</b-form-select-option>
          </template>
        </b-form-select>
        <!-- <VueBootstrapAutocomplete
          class="autocomplete"
          showAllResults
          id="groups"
          :data="groups"
          :serializer="(item) => item.name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedGroup = $event"
        /> -->
      </div>
      <div class="col-12 col-md-6 d-flex justify-content-end">
        <b-button type="button" class="mr-2" variant="success" @click="save()" :disabled="isSaveDisabled">Snimi</b-button>
        
        <b-dropdown right :variant="this.status === 'ALLOW_ORDERING' ? 'success': 'danger'" disabled class="mr-2">
          <template slot="button-content">
              Status: <span style="text-transform: capitalize">{{ this.statuses.find(s => s.key == this.status) ?  this.statuses.find(s => s.key == this.status).value: '' }}</span>
          </template>
          <b-dropdown-item-button  v-for="s of statuses" v-bind:key="s.key" :disabled="status === 'SOFT_ORDERED' || s.key=='SOFT_ORDERED'" @click="setStatus(s.key)">{{ s.value }}</b-dropdown-item-button>
        </b-dropdown>

        <b-dropdown :disabled="!selectedGroup" right variant="primary">
          <template slot="button-content">
            <i class="fas fa-file-download mr-1"></i>
              Preuzmi
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item :disabled="!selectedOrderForm" @click="downloadOrderFormItems()">Porudžbenice - Excel</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-6 col-12">
        <label for="textarea">Napomena: </label>
        <b-form-textarea
          :disabled="!selectedOrderForm"
          id="textarea"
          v-model="note"
          rows="3"
          max-rows="3"
        ></b-form-textarea>

      </div>
    </div>
    <div class="row">
      <div class="col-9">
        <div class="search-box chat-search-box mb-2">
          <div class="position-relative">
            <input input v-model="search" type="text" class="form-control" placeholder="Pretraži..." />
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
      <div class="col-3 align-items-center justify-content-center d-flex">
          <b-form-checkbox
                  v-model="showOrdered"
                  :value="true"
                  :unchecked-value="false"
                  switch
          >
          Prikaži samo poručene artikle
        </b-form-checkbox>
      </div>
    </div>

    <div class="card">
      <div class="card-body card-altered">
        <div class="sticky-top">
          <label v-if="this.budget">Iskorišćen budžet: {{this.calculatePercentage(this.totalPrice, this.budget)}} </label>
          <b-progress :variant="this.budget && this.totalPrice > this.budget ? 'danger' : ''" v-if="this.budget" class="" :max="this.budget">
            <b-progress-bar :value="this.totalPrice"></b-progress-bar>
          </b-progress>
          <div v-if="this.budget && this.totalPrice > this.budget" class="mb-4 text-danger">Budžet je prekoračen. Redukujte količinu proizvoda.</div>
        </div>
        <b-table :items="searchedOrderFormItems" :fields="computedFields" striped responsive
                 class="border-left border-right border-bottom"
        >
          <template v-slot:cell(real_item_id)="data">
            <a @click.prevent="openWindow(data.item.real_item_id)" href="#">
              {{ data.item.real_item_id }}
            </a>
          </template>
        
          <template v-slot:cell(name)="data">
            <a target="_blank" :href="`https://www.bigznet.rs/index.php?route=product/product&product_id=${data.item.real_item_id}`">{{ data.item.name2 }}</a>
          </template>
          <template v-slot:cell(price)="data">
            {{ data.value }} RSD
          </template>
          <template v-slot:cell(amount)="data">
            <div v-if="data.field.editable">
              <b-form-input :class="{'is-invalid': !data.item.isValid}" :disabled="status !== 'ALLOW_ORDERING'" v-model="data.value" @input="onAmountEdit(data.item, data.value)" type="number"/>
              <span class="text-danger" v-if="data.item.validationMessage">
                {{ data.item.validationMessage }}
              </span>
            </div>
            <div v-else>
              <h1>{{ data.value }}</h1>
            </div>
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
.search-box .form-control {
  border-radius: 0.25rem;
}
.autocomplete {
  width: 100%;
}

.sticky-top {
  position: sticky;
  background: white;
  top: -20px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.card-altered {
  max-height: 80vh;
  overflow: auto;
}
</style>
